module.exports = __webpack_public_path__ + "static/img/ba.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pic/ba.png
// module id = 8b9J
// module chunks = 27